import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import VoucherRow from './row';
import { USD } from 'helpers/formatters/number_formats';

export function VouchersTable({ minimal, totals, vouchers }) {
  let colSpan = 6;
  if (minimal) {
    colSpan = colSpan - 2;
  }

  return (
    <React.Fragment>
      <thead>
        <tr>
          <th>Voucher Name</th>
          <th>Close Date</th>
          <th>Identifier</th>
          <th>Status</th>
          {!minimal && <th>Deal Type</th>}
          {!minimal && <th>Property Type</th>}
          <th>Related Contacts</th>
          <th className="text-right">Transaction Value</th>
          <th className="text-right">Gross Commission</th>
          {!minimal && <th className="text-right">Receivables</th>}
        </tr>
      </thead>
      <tbody>
        {vouchers.map(voucher => (
          <VoucherRow
            key={voucher.id}
            minimal={minimal}
            voucher={voucher}
          />
        ))}

        {(!minimal || vouchers.length > 1) && totals && (
          <tr className="tfoot">
            <td>TOTALS</td>
            <td colSpan={colSpan} />
            <td className="text-right">{USD.format(totals.transactionValue)}</td>
            <td className="text-right">{USD.format(totals.grossCommissionAmount)}</td>
            {!minimal && <td className="text-right">{USD.format(totals.uncollectedAmount)}</td>}
          </tr>
        )}
      </tbody>
    </React.Fragment>
  );
}

VouchersTable.propTypes = {
  minimal: PropTypes.bool,
  totals: PropTypes.shape({
    grossCommissionAmount: PropTypes.number,
    transactionValue: PropTypes.number,
  }),
  vouchers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired
};

const mapStateToProps = state => ({
  totals: state.search.totals,
  vouchers: state.search.vouchers
});

export default connect(mapStateToProps)(VouchersTable);
